import { FC } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { WallList } from 'components/Wall'
import { UserProtectedRoute } from 'routes'

// Index route of /board. On desktop the card grid lives in the Board layout;
// on mobile it renders here.
const WallPage: FC = () => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  return <UserProtectedRoute>{!isDesktop && <WallList />}</UserProtectedRoute>
}

export default WallPage
